module.exports = __webpack_public_path__ + "static/media/map.60cc254b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/contact/assets/map.png
// module id = 417
// module chunks = 0